import { api } from "@/builders/axios";

const get = function (id: number) {
  return api.get<{
    order: number;
    subject_id: number;
    assessment_id: number;
    name: string;
  }>(`/setup/topics/${id}`);
};

const put = function (
  id: number,
  data: {
    order: number;
    subject_id: number;
    assessment_id: number;
    name: string;
  }
) {
  return api.post(`/setup/topics/${id}`, data);
};

const patch = function (
  id: number,
  data: Partial<{
    order: number;
    subject_id: number;
    assessment_id: number;
    name: string;
  }>
) {
  return api.patch(`/setup/topics/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/setup/topics/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
